// nativePush.js(Capacitor 전용)의 순수 로직만 따로 뺀 모듈.
// nativePush.js는 최상단에서 ./api/client(axios)를 정적 import하는데, 이 프로젝트의 axios
// 버전이 ESM-only라 Jest(CRA 기본 transformIgnorePatterns)가 node_modules/axios를 못 읽고
// "Cannot use import statement outside a module"로 테스트 자체가 깨진다. 그래서 유닛테스트
// 대상인 순수 함수만 axios/client 의존 없는 이 파일로 분리했다(notificationLink.js와 같은 관례).

const DEFAULT_FALLBACK_LINK = '/maindashboard';

export function isLoggedIn(storage) {
  if (!storage) return false;
  try {
    return Boolean(storage.getItem('access_token') && storage.getItem('user'));
  } catch (e) {
    return false;
  }
}

// 서버가 내려주는 data.link는 이미 검증된 값이어야 하지만, 네이티브 쪽에서도 한 번 더
// 방어한다 - 외부 URL로 네비게이트되는 사고를 막는다(백엔드 NotificationLinkResolver와 같은 규칙).
export function safeInternalLink(link) {
  if (typeof link !== 'string') return null;
  const trimmed = link.trim();
  if (!trimmed || !trimmed.startsWith('/') || trimmed.startsWith('//')) return null;
  if (/[\n\r\t]/.test(trimmed)) return null;
  return trimmed;
}

// 푸시를 탭했을 때 할 일 - 로그인 상태가 아니면 당장 navigate할 화면(로그인 화면)이 없으므로
// 링크를 잠시 보관해뒀다가 로그인 완료 후에 이어서 연다.
export function decideTapAction(link, loggedIn) {
  const safeLink = safeInternalLink(link) || DEFAULT_FALLBACK_LINK;
  return loggedIn ? { action: 'navigate', link: safeLink } : { action: 'stash', link: safeLink };
}
